import { useQuery } from '@apollo/client';
import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Redirect, useHistory } from 'react-router-dom';

import {
  GetUserQueryGQLType,
  GetUserQueryVariablesGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { FundingRequestDetailViewContainer } from 'capitalProvider/domains/fundingRequests/ui/detail/ViewContainer';
import {
  dashboardRoutePadding,
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { useGetFundingRequestQuery } from 'packages/funding-requests/requests/requests.gql.generated';
import { GET_USER } from 'requests/queries.gql';

interface FundingRequestRouteMatchParams {
  fundingRequestId: string; // TODO: change to use UUID type in the future, if possible
}

interface FundingRequestRouteProps
  extends RouteComponentProps<FundingRequestRouteMatchParams> {}

export const FundingRequestRoute = (routeParams: FundingRequestRouteProps) => {
  const { fundingRequestId } = routeParams.match.params;
  const toast = useToast();
  const history = useHistory();

  const { data: userData, loading: userLoading } = useQuery<
    GetUserQueryGQLType,
    GetUserQueryVariablesGQLType
  >(GET_USER);

  const {
    data: fundingRequestData,
    loading: fundingRequestDataLoading,
    error,
  } = useGetFundingRequestQuery({
    variables: { fundingRequestId },
  });

  if (
    !userData ||
    userLoading ||
    !fundingRequestData ||
    fundingRequestDataLoading
  ) {
    return (
      <Skeleton height="600px" data-testid="draw-request-id-route-loading" />
    );
  }
  const { user } = userData;

  if (error || !user) {
    return <Redirect to="/funding-requests" />;
  }

  let routeLevelError = false;
  return (
    <Box padding={dashboardRoutePadding}>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load draw requests page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/funding-requests');
          }
        }}
      >
        <FundingRequestDetailViewContainer
          fundingRequestId={fundingRequestId}
          creditFacilityId={
            fundingRequestData.fundingRequestWithFullDetails.creditFacilityId
          }
        />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
